<template>
  <div class="c-keyboard" @touchstart="keyPress">
    <div class="row">
      <div class="item" data-value="1">1</div>
      <div class="item" data-value="2">2</div>
      <div class="item" data-value="3">3</div>
    </div>
    <div class="row">
      <div class="item" data-value="4">4</div>
      <div class="item" data-value="5">5</div>
      <div class="item" data-value="6">6</div>
    </div>
    <div class="row">
      <div class="item" data-value="7">7</div>
      <div class="item" data-value="8">8</div>
      <div class="item" data-value="9">9</div>
    </div>
    <div class="row">
      <div class="item" data-value=""></div>
      <div class="item" data-value="0">0</div>
      <div class="item delete" data-value="del">删除</div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  export default {
    name: 'c-keyboard',
    data () {
      return {}
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {
      keyPress () {
        let pressValue = (event.target.attributes['data-value'] || {}).value || ''
        if (pressValue === '') return
        if (pressValue === 'del') return this.$emit('key-del')
        this.$emit('key-press', pressValue)
      }
    },
    computed: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?6f54bfb8